import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import cardShape from 'app/shapes/cardShape';

import './EventLocation.scss';

export default function EventLocation({ card, trackClick }) {
  if (card.get('location')) {
    const locationName = card.getIn(['location', 'name']);
    const label = (
      <>
        <span aria-hidden>{locationName}</span>
        <ScreenReaderMessage>
          <FormattedMessage id="sr_event_location" values={{ locationName }} />
        </ScreenReaderMessage>
      </>
    );

    if (card.getIn(['location', 'url'])) {
      return (
        <Link
          href={card.getIn(['location', 'url'])}
          className="cp-event-location"
          dataKey="event-location-link"
          handleClick={() => trackClick({ linkText: locationName })}
        >
          {label}
        </Link>
      );
    }
    return <span className="cp-event-location">{label}</span>;
  }

  return null;
}

EventLocation.defaultProps = {
  trackClick: () => {}
};

EventLocation.propTypes = {
  card: cardShape.isRequired,
  trackClick: PropTypes.func
};
